import React, {Fragment} from "react";
import {Card, CardContent, Grid, Typography} from "@mui/material";
import {sprintf} from "sprintf-js";
import {ChecklistField} from "../formFields/ChecklistField";
import ChecklistItemDefault from "../defaults/ChecklistItemDefault";

const [section, name, title] = [5, "SecondaryRooms", "All Secondary Rooms (Rooms not used for living)"];

const SecondaryRoomsDefaults = () => {
    return {
        "5": {
            "1": ChecklistItemDefault,
            "2": ChecklistItemDefault,
            "3": ChecklistItemDefault,
        }
    };
}

const SecondaryRooms = () => {
    const relPath = name;
    return (
        <Fragment>
            <Card>
                <CardContent>
                    <Typography variant={"h6"} gutterBottom>
                        {sprintf("%d. %s", section, title)}
                    </Typography>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "security")}
                            rank={"5.1"}
                            room={name}
                            desc={"Security"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "electricalHazard")}
                            rank={"5.2"}
                            room={name}
                            desc={"Free of Electrical Hazards"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "otherHazard")}
                            rank={"5.3"}
                            room={name}
                            desc={"Free of Other Potentially Hazardous features in these rooms"}
                            section={section}
                        />
                    </Grid>
                </CardContent>
            </Card>
        </Fragment>
    );
}

export default SecondaryRooms;
export {SecondaryRoomsDefaults};